import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import {
  AppsDevelopedIOS,
  IosClutch,
  IosExperts,
  IosIndustry,
} from "../../../app-constants";

function GameNumbers(props) {
  return (
    <section className="awrads_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={3}>
            <div className="number_items">
              {AppsDevelopedIOS}
              <div className="title_numbers">
                70+
                <span>Apps Developed</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="number_items">
              {IosExperts}
              <div className="title_numbers">
                40+
                <span>iOS Experts</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="number_items">
              {IosClutch}
              <div className="title_numbers">
                75+
                <span>Clutch Reviews</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="number_items">
              {IosIndustry}
              <div className="title_numbers">
                15+
                <span>Industries Served</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default GameNumbers;
